import React from "react";

export interface FormProps extends Omit<React.FormHTMLAttributes<HTMLFormElement>, "onSubmit"> {
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  noValidate?: boolean;
  className?: string;
  children?: React.ReactNode;
}

function Form({ onSubmit, noValidate = true, className, children, ...rest }: FormProps) {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (onSubmit) {
      onSubmit(event);
    }
  };

  const classes = ["ui-form", className].filter(Boolean).join(" ");

  return (
    <form {...rest} className={classes} noValidate={noValidate} onSubmit={handleSubmit}>
      {children}
    </form>
  );
}

export default Form;
